import { api } from "../../../../../../services/core-api-service"

export const signOut = () => {
    api.auth.signOut()
}